module.exports = "//public.getcloudapp.com/packs/media/images/illustrations-transcription-processing-db300c1a6f5539c840ddcf9d55d5aed6.svg";